var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_"},[_c('navbar'),_c('div',{staticClass:"breadcrum_"},[_vm._v("首页 > 理赔流程")]),_c('div',{staticClass:"con_"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data)}})]),_c('footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }